/**
 * Created by lihanying on 2017/7/14.
 */
import { GETCLUBWALLET } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBWALLET:
      return Object.assign({}, state, { walletInfo: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubMember/reduce.js